export const etAdminMenu = [
  {
    key: 'dashboard',
    title: 'Dashboard',
    route: '/main/dashboard',
    icon: 'dashboard',
    children: [],
  },
  {
    key: 'sales',
    title: 'Sales',
    icon: 'shopping-cart',
    children: [
      {
        key: 'orders',
        title: 'Orders',
        route: '/main/order',
        icon: 'ordered-list',
        children: [],
      },
      {
        key: 'returns',
        title: 'Returns',
        route: '/main/returns',
        icon: 'rollback',
        children: [],
      },
      {
        key: 'abandoned-carts',
        title: 'Abandoned Carts',
        route: '/main/abandoned-carts',
        icon: 'shopping-cart',
        children: [],
      },
      {
        key: 'schemes',
        title: 'Schemes',
        route: '/main/schemes',
        icon: 'gift',
        children: [],
      },
    ],
  },
  {
    key: 'catalog',
    title: 'Catalog',
    icon: 'appstore',
    children: [
      {
        key: 'items',
        title: 'Item',
        route: '/main/item',
        icon: 'shopping',
        children: [],
      },
      {
        key: 'categories',
        title: 'Categories',
        route: '/main/categories',
        icon: 'appstore',
        children: [],
      },
      {
        key: 'collection',
        title: 'Collection',
        route: '/main/collection',
        icon: 'tags',
        children: [],
      },
      {
        key: 'metal-price',
        title: 'Metal Price',
        route: '/main/metal-price',
        icon: 'gold',
        children: [],
      },
    ],
  },
  {
    key: 'customers',
    title: 'Customers',
    icon: 'team',
    children: [
      {
        key: 'customer',
        title: 'Customer',
        route: '/main/user',
        icon: 'user',
        children: [],
      },
      {
        key: 'customer-request',
        title: 'Customer Request',
        route: '/main/customer-request',
        icon: 'message',
        children: [],
      },
      {
        key: 'review',
        title: 'Reviews',
        route: '/main/review',
        icon: 'star',
        children: [],
      },
    ],
  },
  {
    key: 'content',
    title: 'Content',
    icon: 'layout',
    children: [
      {
        key: 'banner',
        title: 'Banner',
        route: '/main/banner',
        icon: 'picture',
        children: [],
      },
      {
        key: 'dynamic-section',
        title: 'Dynamic Section',
        route: '/main/dynamic-section',
        icon: 'layout',
        children: [],
      },
      {
        key: 'gallery',
        title: 'Gallery',
        route: '/main/gallery',
        icon: 'file-image',
        children: [],
      },
      {
        key: 'blogs',
        title: 'Blogs',
        route: '/main/blogs',
        icon: 'file-text',
        children: [],
      },
      {
        key: 'newsletter-subscribers',
        title: 'Newsletter Subscribers',
        route: '/main/newsletter-subscribers',
        // /logs lives under this path; match exactly so both don't highlight
        exact: true,
        icon: 'mail',
        children: [],
      },
      {
        key: 'newsletter-logs',
        title: 'Notification Logs',
        route: '/main/newsletter-subscribers/logs',
        icon: 'history',
        children: [],
      },
    ],
  },
  {
    key: 'store-settings',
    title: 'Store',
    icon: 'setting',
    children: [
      {
        key: 'general-info',
        title: 'General Info',
        route: '/main/general-info',
        icon: 'info-circle',
        children: [],
      },
      {
        key: 'contact',
        title: 'Contact',
        route: '/main/contact-info/contact',
        icon: 'contacts',
        children: [],
      },
      {
        key: 'bespok-contact',
        title: 'Bespoke Contact',
        route: '/main/contact-info/bespoke-contact',
        icon: 'contacts',
        children: [],
      },
      {
        key: 'settings',
        title: 'Settings',
        route: '/main/settings',
        icon: 'setting',
        children: [],
      },
    ],
  },
];
